import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { getAssessmentFetch } from "store/middlewares/assessment.crud"
import { useParams, useSearchParams } from "react-router-dom"
import { markingWordsHooks } from "pages/Admin/TranscriptionSystem/MarkingWords"

const useGetAssessment = (assessmentId) => {
    const dispatch = useDispatch()
    const currentAssessment = useSelector(state => state.assessment.assessment)
    const params = useParams()
    const [searchParams] = useSearchParams();

    const isTraining = markingWordsHooks.useIsTraining()

    let assessmentID = params?.assessmentID || assessmentId

    if (!assessmentID)
        assessmentID = currentAssessment?.id || searchParams.get('assessment')

    return useQuery(
        {
            queryKey: [qc.assessment, assessmentID],
            queryFn: async ({ signal }) => {
                const { data } = await getAssessmentFetch({ id: assessmentID, signal, }, isTraining)
                dispatch(actions.updateAssessment(data))
                dispatch(actions.editTestTaker({ test_taker_id: data.test_taker_id }))
            },
            enabled: !!assessmentID,
        })
}

export default useGetAssessment